import { boolean, InferType, object, string } from "yup";

export type IFormularioCadisSchema = InferType<typeof formCadisSchema>;

export const formCadisSchema = object({
  date: string().required(),
  empresa: string().required(),
  selecionarPeriodo: boolean().required(),
  inicio: string().nullable(),
  fim: string().nullable(),
  tipoDePesquisa: string().required()
});
